import { http } from './http'

export const logoutPreview = () => {
  return http().put(`/api/admin/preview/logout`)
}
